import React from 'react';
import { usePromiseTracker } from 'react-promise-tracker';
import LoadingIndicator from './loadingIndicator';
/* import Loader from 'react-loader-spinner'; */
const PromiseLoadingIndicator = (props) => {
  const { promiseInProgress } = usePromiseTracker();
  return promiseInProgress && <LoadingIndicator />;
};
export default PromiseLoadingIndicator;
